import { render } from "./TaskSettings.vue?vue&type=template&id=e1f2a09a&scoped=true"
import script from "./TaskSettings.vue?vue&type=script&lang=js"
export * from "./TaskSettings.vue?vue&type=script&lang=js"

import "./TaskSettings.vue?vue&type=style&index=0&id=e1f2a09a&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f2a09a"]])

export default __exports__